import { motion } from "framer-motion";

function scoreColor(score) {
  if (score >= 70) return "#8BA888";
  if (score >= 45) return "#D4AF37";
  return "#C87979";
}

export const ScoreRing = ({ score = 0, size = 220, stroke = 14, testId }) => {
  const radius = (size - stroke) / 2;
  const circumference = 2 * Math.PI * radius;
  const clamped = Math.max(0, Math.min(100, score));
  const offset = circumference - (clamped / 100) * circumference;
  const color = scoreColor(clamped);

  return (
    <div className="relative inline-flex items-center justify-center" data-testid={testId}>
      <svg width={size} height={size} className="-rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="#E8E6E1"
          strokeWidth={stroke}
        />
        <motion.circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={circumference}
          initial={{ strokeDashoffset: circumference }}
          animate={{ strokeDashoffset: offset }}
          transition={{ duration: 1.4, ease: "easeOut" }}
          style={{ filter: `drop-shadow(0 0 12px ${color}66)` }}
        />
      </svg>
      <div className="absolute flex flex-col items-center">
        <motion.span
          className="font-display leading-none"
          style={{ color, fontSize: size * 0.28 }}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.5, duration: 0.6 }}
          data-testid="glow-score-value"
        >
          {Math.round(clamped)}
        </motion.span>
        <span className="text-[11px] uppercase tracking-[0.25em] text-[#7A7571] mt-1">
          Glow Score
        </span>
      </div>
    </div>
  );
};

export default ScoreRing;
